import { manageVerificationResultMethods } from '@/views/onboarding_system_views/Gates/Verification/manage_verification_result_methods';
import { get_service_field_label_candidates } from '@/views/onboarding_system_views/Gates/Verification/manage_verification_helpers';

export const queueFormHistoryResultMethods = {
  get_check_history(item = {}) {
    return manageVerificationResultMethods.get_check_history.call(this, item);
  },
  get_check_field_results(item = {}) {
    return manageVerificationResultMethods.get_check_field_results.call(this, item);
  },
  get_expected_verification_fields(item = {}) {
    const candidates = get_service_field_label_candidates(item?.service || {});
    return candidates.map((label, index) => ({
      key: `${String(label || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_') || `field_${index + 1}`}`,
      label
    }));
  },
  get_case_forms_for_check() {
    return Array.isArray(this.hydrated_case_detail?.forms) ? this.hydrated_case_detail.forms : [];
  },
  get_check_result_detail_rows(item = {}) {
    return manageVerificationResultMethods.get_check_result_detail_rows.call(this, item);
  },
  get_check_passed_chips(item = {}) {
    return manageVerificationResultMethods.get_check_passed_chips.call(this, item);
  },
  get_automatic_result_summary(item = {}) {
    return manageVerificationResultMethods.get_automatic_result_summary.call(this, item);
  },
  get_check_history_run_by(item = {}) {
    return manageVerificationResultMethods.get_check_history_run_by.call(this, item);
  },
  get_check_history_duration(item = {}) {
    return manageVerificationResultMethods.get_check_history_duration.call(this, item);
  },
  format_history_date(value = '') {
    const raw = String(value || '').trim();
    if (!raw || raw === '-') return '-';
    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toISOString().slice(0, 10);
    }
    return raw.slice(0, 10) || raw;
  },
  format_history_match_status(value = '') {
    const normalized = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ');
    if (!normalized) return 'Not reviewed';
    return normalized.replace(/\b\w/g, (char) => char.toUpperCase());
  },
  history_match_status_badge_class(value = '') {
    const normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'match') return 'bg-success-subtle text-success-emphasis';
    if (normalized === 'mismatch') return 'bg-danger-subtle text-danger-emphasis';
    return 'bg-secondary-subtle text-secondary-emphasis';
  },
  history_manual_decision_action() {
    const normalized_status = String(this.history_manual_run?.status || '').trim().toLowerCase();
    if (['pass', 'approved', 'approve'].includes(normalized_status)) return 'approve';
    if (['partial', 'request_changes', 'request changes'].includes(normalized_status)) return 'request_changes';
    if (['rejected', 'reject'].includes(normalized_status)) return 'reject';
    return '';
  },
  history_manual_decision_label() {
    const action = this.history_manual_decision_action();
    if (action === 'approve') return 'Approved';
    if (action === 'request_changes') return 'Request Changes';
    if (action === 'reject') return 'Rejected';
    return this.format_history_value(this.history_manual_run?.status);
  },
  history_manual_document_status_class(item = {}) {
    return String(item?.status || '').trim().toLowerCase() === 'verified'
      ? 'bg-success-subtle text-success-emphasis'
      : 'bg-light text-muted';
  }
};
